import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'
import { ColorContainerDotPlotsBoxData } from './color-container-dot-plots-box/color-container-dot-plots-box.component.converter'

@Injectable({ providedIn: 'root' })
export class ColorContainerDotPlotsBoxesConverter extends CmsConverterService<ColorContainerDotPlotsBoxesData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      header: formData.st_header ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      footer: formData.st_footer ?? defaultTextInput,
      boxes: formData.st_dot_plots_boxes ?? defaultFSCatalog,
      fourBoxesLayout: formData.st_fourBoxesLayout?.value ?? false
    }
  }
}

export const COLOR_CONTAINER_DOT_PLOTS_BOXES_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, ColorContainerDotPlotsBoxesData>>('ColorContainerDotPlotsBoxesConverter')

export interface ColorContainerDotPlotsBoxesData extends ConvertedComponentData {
  boxes: FsCatalog<ColorContainerDotPlotsBoxData>;
  header: TextInput;
  headline: TextInput;
  footer: TextInput;
  fourBoxesLayout: boolean;
}
